<!-- eslint-disable max-len -->
<template>
  <Dialog
    v-model:visible="state$$.policyModal.isVisible"
    :class="['register-polity-dialog', {
      'register-polity-dialog--verano-joven': typePortal === 'verano-joven',
      'register-polity-dialog--codigos': typePortal === 'codigos',
    }]"
    :dismissable-mask="false"
    :modal="true"
    style="max-width: 700px"
    :breakpoints="{ '960px': '75vw', '641px': '100vw' }"
  >
    <template #header>
      {{ modelRef.policyModal.title }}
    </template>

    <ScrollPanel style="width: 100%">
      <p class="register-polity-dialog__title">
        Consentimiento tratamiento datos de carácter personal
      </p>
      <p>
        {{ !state$$.formRegister.isTutorize ? 'Doy consentimiento de forma voluntaria, específica e inequívoca para aceptar el tratamiento de datos de carácter personal que me concierne.' : 'Doy consentimiento de forma voluntaria, específica e inequívoca para aceptar el tratamiento de datos de carácter personal que me concierne tanto a mí, como a los menores de edad de los que aporto datos, por el ser el titular de la patria potestad o tutela del mismo, o estar autorizado para ello' }}
      </p>
      <p>
        {{ typePortal === 'verano-joven' ? `La finalidad que ampara el tratamiento es la promoción del uso del
        transporte público colectivo terrestre por parte de los jóvenes amparada
        por el RDL ${ rdlTexts }.`: `La finalidad que ampara el tratamiento es la promoción del uso del transporte público colectivo terrestre amparada por el RDL ${rdlTexts}.` }}
      </p>
      <p>
        Sus datos serán tratados únicamente con la finalidad del tratamiento, y
        serán conservados durante el tiempo necesario para garantizar una
        adecuada asistencia y la finalidad de la medida.
      </p>
      <p>
        Los datos de contacto proporcionados serán cedidos a los operadores de
        transporte para comunicaciones relacionadas con este tratamiento
        exclusivamente.
      </p>
      <p>
        El resto de datos personales no serán cedidos a terceros salvo en los
        casos obligados por la Ley.
      </p>
      <p>
        El Responsable del tratamiento de datos es la Dirección General de
        Transporte por Carretera y Ferrocarril.
      </p>
      <p>
        Podrá contactar con el Delegado de Protección de Datos en el buzón
        <a href="mailto:dpd.dgoi@transportes.gob.es">dpd.dgoi@transportes.gob.es</a>, y ejercer sus derechos
        contemplados en
        la Ley Orgánica 3/2018, de 5
        de diciembre, de Protección de Datos Personales y garantía de los
        derechos digitales así como en el Reglamento General de Protección de
        Datos (Reglamento 2016/679 UE).
      </p>
      <p>
        Puede acceder a más información sobre la protección de datos en el
        portal del MINISTERIO DE TRANSPORTES Y MOVILIDAD SOSTENIBLE:
      </p>
      <a
        href="https://www.transportes.gob.es/el-ministerio/buen-gobierno/proteccion-datos-personales"
        target="_blank"
      >https://www.transportes.gob.es/el-ministerio/buen-gobierno/proteccion-datos-personales</a>
    </ScrollPanel>

    <template #footer>
    </template>
  </Dialog>
</template>

<script setup>
// #region VUE
import {inject, computed, ref} from 'vue';
import {useStore} from 'vuex';
// #endregion

// #region Components
import Dialog from 'primevue/dialog/sfc';
import ScrollPanel from 'primevue/scrollpanel/sfc';
// #endregion

// #region Params, Ref, Reactives, Computed
const store = useStore();

const state$$ = inject('registerState$$');
const {modelRef} = inject('registerModel');

const typePortal = ref(STTEDRA_TYPE_PORTAL);
const rdlTexts = computed(() => store.getters['text/getSectionTexts']('rdl'));
// #endregion
</script>

<style lang="scss">
@use "@/styles/vars" as *;
@use "@/styles/breakpoints" as *;

.register-polity-dialog {

  &--codigos{
   .p-dialog-header{
    .p-dialog-header-icon{
        svg{
          color: white
        }
        &:hover{
          svg{
            color: var(--color--primary);
          }
        }
      }
    }
  }

  p {
    @include media("<=tablet") {
      font-size: $pv__fs--xlarge--phone;
    }

    @include media(">tablet") {
      font-size: $pv__fs--large;
    }
  }

  &__title {
    font-weight: bold;
    margin-bottom: $brand__boxspace--small;
  }
}
</style>
